export default __webpack_public_path__ + "static/media/login-page.1cff0537.jpg";